import Axios from "axios";
//import { EligibilitySettings } from '../models/eligibility-settings';
import { FplSettings } from '../models/fpl-settings';

export class SettingsService {
  private _api = Axios.create({
    baseURL: process.env.VUE_APP_ECE_API_URL,
    responseType: 'json',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-api-key': 'eaQSPYWOqAbDOpjX3zFC2bDJvh6z7wB3wV888d25'
    }
  });

  /*
  async getEligibilitySettings(): Promise<EligibilitySettings> {
    const response = await this._api.get<EligibilitySettings>(`/Setttings/Eligiblity`)
    return response.data;
  }
  */
  
  async getFPLSettings(): Promise<FplSettings> {
    const response = await this._api.get<FplSettings>(`/Settings/Fpl`)
    return response.data;
  }
}
